import React, { Component } from 'react';
import { AuthContext } from "./../../../context/auth";
import {StripeKey} from './../../../constants';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import SplitForm from './SplitForm';
import {withSnackbar} from "react-simple-snackbar";

class PaymentComponent extends Component{
    static contextType = AuthContext;
    stripePromise = loadStripe(StripeKey);
    state = {
        promo_applied: false
    }

    render(){
        return (
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="container-payment">
                        <div className="payment-gateway-outer">
                            <div className="payment-apply-promo-outer">
                                <Elements stripe={this.stripePromise}>
                                    <SplitForm data={this.props.location.state.data} promo_applied={this.state.promo_applied} last_used_promo={this.context.lastUsedPromo}/>
                                </Elements>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withSnackbar(PaymentComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});